import http from "./http";

const notificacao = {
  postAll: data => http.post("/messaging/all", data),

  postCompany: (company, data) => http.post(`/messaging/${company}`, data),

  postUpdateTokens: () => http.post("/topics/all"),
};

export default notificacao;


